import clsx from "clsx";
import { SelectProps } from "./Select.types";
import { Select as BaseSelect } from "@commonlibs";

function Select<T, Multiple extends boolean = false>({
    size = "md",
    variant = "outlined",
    rounded = false,
    className,
    children,
    options,
    placeholder = "",
    nothingToShow,
    readonly,
    ...rest
}: SelectProps<T, Multiple>): JSX.Element {
    const isEmpty = !children && options?.length === 0;
    return (
        <BaseSelect
            className={clsx(size.capitalize(), variant.capitalize(), rounded ? "Rounded" : undefined, className)}
            placeholder={isEmpty ? nothingToShow : placeholder}
            options={options}
            readonly={readonly || isEmpty}
            {...rest}
        >
            {children}
        </BaseSelect>
    );
}

export default Select;
